// Grupo único (Rafael 30/10, D-0134): cada grupo só aparece 1 vez no orçamento ou no modelo, para todos os
// grupos e clientes. Quem já tem repetição gravada abre e salva, com aviso, mas não aceita nova: por grupo, a
// quantidade na tela não passa de max(1, quantidade gravada). A API tem a mesma regra (OrcamentoGrupoUnico.php).

import { AgenciaOrcamentoPolicy } from './agenciaOrcamentoPolicy';

export const MSG_CLONAR_GRUPO_UNICO = 'Cada grupo só pode aparecer 1 vez, por isso o grupo não se clona. Para repetir um item, use o Clonar da linha.';
export const SUFIXO_GRUPO_JA_INCLUIDO = ' (já incluído)';

const idGrupo = (grupo) => {
    const produto = grupo?.produto;
    const id = produto && typeof produto === 'object' ? produto.id : produto;
    return id === null || id === undefined || id === '' ? '' : String(id);
};

export function contarGrupos(grupos = []) {
    const contagem = {};
    (grupos || []).forEach((grupo) => {
        const id = idGrupo(grupo);
        if (id) contagem[id] = (contagem[id] || 0) + 1;
    });
    return contagem;
}

// Opção do seletor: o grupo já está em OUTRA linha. A própria linha continua podendo manter o que tem.
export function grupoJaIncluido(idOpcao, grupos = [], indexAtual = -1) {
    const id = idOpcao === null || idOpcao === undefined ? '' : String(idOpcao);
    if (!id) return false;
    return (grupos || []).some((grupo, index) => index !== indexAtual && idGrupo(grupo) === id);
}

function repeticoes(grupos = [], gravados = {}) {
    const contagem = contarGrupos(grupos);
    return Object.keys(contagem).filter((id) => contagem[id] > 1).map((id) => {
        const grupo = (grupos || []).find((g) => idGrupo(g) === id);
        return {
            nome: AgenciaOrcamentoPolicy.nomeGrupoExibicao(grupo?.produto) || 'Grupo',
            quantidade: contagem[id],
            permitido: Math.max(1, Number(gravados?.[id]) || 0),
        };
    });
}

// `onde`: 'orçamento' ou 'modelo'. Devolve o formato das faixas acima do rodapé: bloqueiam o Salvar / só avisam.
export function listarGruposRepetidos(grupos = [], gravados = {}, onde = 'orçamento') {
    const lista = repeticoes(grupos, gravados);
    return {
        bloqueiam: lista.filter((r) => r.quantidade > r.permitido).map((r) => ({
            tipo: 'grupo_repetido',
            mensagem: r.permitido > 1
                ? `${r.nome}: já estava ${r.permitido} vezes neste ${onde} e não aceita nova repetição. Remova o grupo a mais.`
                : `${r.nome}: já está neste ${onde}. Cada grupo só pode aparecer 1 vez: remova o repetido.`,
        })),
        avisos: lista.filter((r) => r.quantidade <= r.permitido).map((r) => ({
            tipo: 'grupo_repetido_legado',
            mensagem: `${r.nome} aparece ${r.quantidade} vezes. Este ${onde} salva normalmente, mas não aceita nova repetição.`,
        })),
    };
}

// Modelo com grupo repetido (ou orçamento virando modelo): os itens dos repetidos entram no primeiro, na ordem.
// Modelo só guarda produto, então nada se perde. Não muda os objetos recebidos.
export function juntarGruposRepetidos(grupos = []) {
    const primeiroPorId = new Map();
    const juntados = [];
    const resultado = [];
    (grupos || []).forEach((grupo) => {
        const id = idGrupo(grupo);
        const primeiro = id ? primeiroPorId.get(id) : null;
        if (!primeiro) {
            const copia = { ...grupo, subitem: [...(grupo.subitem || [])] };
            if (id) primeiroPorId.set(id, copia);
            resultado.push(copia);
            return;
        }
        primeiro.subitem.push(...(grupo.subitem || []));
        const nome = AgenciaOrcamentoPolicy.nomeGrupoExibicao(grupo.produto) || 'Grupo';
        if (!juntados.includes(nome)) juntados.push(nome);
    });
    return { grupos: resultado, juntados };
}

// Mostra na lista do seletor por que a opção está apagada.
export function rotuloOpcaoGrupo(opcao, contexto, grupos = [], indexAtual = -1) {
    return contexto === 'menu' && grupoJaIncluido(opcao?.value, grupos, indexAtual)
        ? `${opcao?.label ?? ''}${SUFIXO_GRUPO_JA_INCLUIDO}`
        : opcao?.label;
}
